import { useEffect } from "react";
import { useBranding } from "@/lib/branding";

/**
 * Injects the Tawk.to live-chat script when the admin has pasted the two public IDs
 * (tawk_property_id + tawk_widget_id) in Branding. Idempotent — safe to render on every page.
 * We hide the Tawk floating button by default so our WelcomeBubble stays the entry point.
 * The bubble opens Tawk via window.Tawk_API.toggle() when the visitor taps "Send a message".
 */
export default function TawkLoader() {
  const { branding } = useBranding();
  const propertyId = branding?.tawk_property_id?.trim();
  const widgetId = branding?.tawk_widget_id?.trim();

  useEffect(() => {
    if (!propertyId || !widgetId) return;
    if (window.__TAWK_LOADED__) return;
    window.__TAWK_LOADED__ = true;
    // Hide the default Tawk bubble so our WelcomeBubble is the only entry point.
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_API.customStyle = { visibility: { desktop: { position: "br", xOffset: 24, yOffset: 24 }, mobile: { position: "br", xOffset: 12, yOffset: 12 } } };
    window.Tawk_API.onLoad = function () {
      try { window.Tawk_API.hideWidget && window.Tawk_API.hideWidget(); } catch (_) {}
    };
    window.Tawk_LoadStart = new Date();
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://embed.tawk.to/${propertyId}/${widgetId}`;
    s.charset = "UTF-8";
    s.setAttribute("crossorigin", "*");
    document.head.appendChild(s);
    return () => {
      // do NOT remove — Tawk expects to persist during SPA navigation
    };
  }, [propertyId, widgetId]);

  return null;
}
